import { FormControl, Grid, InputAdornment, Select, Table, TableBody, TableCell, TableRow
    , TextField, Typography, IconButton, Tooltip, InputLabel, Box } from '@mui/material'
import { AddCircle as IconAddCircle, Delete as IconDelete, Search as IconSearch, Edit as IconEdit } from "@mui/icons-material";
import api from "../../services/api";
import React, { useEffect, useState, useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
    add, remove, setValue, setEntity,
    setListCargo, setListEstadoLaboral, defaultEntity,
    setValidations, init
} from '../../redux/person/personRepresentativeSlice'
import PersonSearch from './PersonSearch'
import PersonRegister from './PersonRegister';
import DialogYesNo from '../common/DialogYesNo'
import { FormHelperText as HelperText } from '@mui/material';
import * as personaService from "../../services/personaService";
import * as catalogoService from "../../services/catalogoService";
import * as positionService from "../../services/positionService";

const PersonRepresentative = (props) => {
    const dispatch = useDispatch();
    const sliceKey = props.sliceKey;
    const isReadOnly = props.isReadOnly;

    useEffect(() => {
        dispatch(init({ sliceKey }));
    }, [dispatch, sliceKey]);

    const mainEntity = useSelector((state) => state.personRepresentative[sliceKey]?.entity)
    const listCargo = useSelector((state) => state.personRepresentative[sliceKey]?.listCargo)
    const listEstadoLaboral = useSelector((state) => state.personRepresentative[sliceKey]?.listEstadoLaboral)
    const validate = useSelector((state) => state.personRepresentative[sliceKey]?.validationActive);

    const [openSearchPersona, setOpenSearchPersona] = useState(false)
    const openCloseSearchPersona = () => { setOpenSearchPersona(!openSearchPersona); }
    const [openPersonRegister, setOpenPersonRegister] = useState(false)
    const openClosePersonRegister = () => { setOpenPersonRegister(!openPersonRegister); }
    const [openDialogDelete, setOpenDialogDelete] = useState(false)
    const openCloseDialogDelete = () => { setOpenDialogDelete(!openDialogDelete); }
    const [selectNumero, setSelectNumero] = useState(null);
    const [selectId, setSelectId] = useState(null);

    const validation = useMemo(() => {
        return {
        };
    }, [
        mainEntity,
    ]);

    const setItemValue = (numero, name, value) => {
        dispatch(setValue({sliceKey: sliceKey, numero: numero, name: name, value: value}))
    }

    const fetchMainEntity = useCallback(async () => {
        const response = await personaService.GetsPersonaRepresentanteViewById(props.id);
        dispatch(setEntity({sliceKey: sliceKey, data: Array.isArray(response) && response.length > 0 ? response : defaultEntity }));
    }, [dispatch, sliceKey, props.id])
    const fetchListCargo = useCallback(async () => {
        const response = await positionService.GetsCargoViewSearchBasic("", 2)
        dispatch(setListCargo({sliceKey: sliceKey, data: response}));
    }, [])
    const fetchListEstadoLaboral = useCallback(async () => {
        const response = await catalogoService.getCatalogosByPadre(154)
        dispatch(setListEstadoLaboral({sliceKey: sliceKey, data: response}));
    }, [])

    useEffect(() => {
        fetchMainEntity();
        fetchListCargo();
        fetchListEstadoLaboral();
    }, [fetchMainEntity])

    const validateDocuments = (documents) => {
        const errors = [];

        return [...new Set(errors)];
    };

    const validationMessages = useMemo(() => {
        return validateDocuments(mainEntity ?? []);
    }, [mainEntity]);

    const prevValidationMessages = React.useRef()

    useEffect(() => {
        if (JSON.stringify(prevValidationMessages.current) !== JSON.stringify(validationMessages)) {
            prevValidationMessages.current = validationMessages
            dispatch(setValidations({
                sliceKey,
                message: validationMessages
            }))
        }
    }, [dispatch, sliceKey, validationMessages])

    const setPersonSaved = (result) => {
        console.log(result)
        setItemValue(selectNumero, "idRepresentante", result.id)
        setItemValue(selectNumero, "representante", result.nombres)
    }
    const setSelectSearchPersona = (select) => {
        setItemValue(selectNumero, "idRepresentante", select.idPersona)
        setItemValue(selectNumero, "representante", select.nombres)
    }

    const deleteMainEntity = async () => {
        await personaService.DeletePersonaRepresentante(props.id)
        dispatch(remove({sliceKey: sliceKey, numero: selectNumero}));
    }

    return (
        <Grid container>
            <Grid item>
                <Typography variant="h7">
                    <Box sx={{ fontWeight: 'bold' }} padding={0}>
                        {"Representantes (" + (mainEntity?.length || 0) + ")"}
                    </Box>
                </Typography>
            </Grid>
            <Grid item>
                <Tooltip title={"Agregar Representante"}>
                    <IconButton size="small" aria-label="Agregar Representante" style={{height: 10}} disabled={isReadOnly} onClick={() => {
                        dispatch(add(sliceKey));
                    }}>
                        <IconAddCircle />
                    </IconButton>
                </Tooltip>
            </Grid>
            <Grid container>
                {/* {JSON.stringify(validation)} */}
                <Table size="small">
                    <TableBody>
                        {mainEntity?.map((row, index) => (
                            <TableRow key={row.numero} sx={(theme) => ({
                                backgroundColor: index % 2 === 1 ? theme.palette.action.selected : 'inherit',
                                "&:last-child td, &:last-child th": { borderRadius: "0.5em" },
                            })}>
                                <TableCell>
                                    <Grid container spacing={1} padding={0}>
                                        <Grid item xs={12} sm={3}>
                                            <FormControl required fullWidth>
                                                <InputLabel htmlFor="input-cargo">Cargo</InputLabel>
                                                <Select
                                                    native
                                                    label="Cargo"
                                                    value={row.idCargo || 0}
                                                    fullWidth
                                                    onChange={(event, newValue) => {
                                                        var id = event.nativeEvent.target.selectedIndex;

                                                        setItemValue(row.numero, "idCargo", event.target.value)
                                                        setItemValue(row.numero, "cargo", event.nativeEvent.target[id].text)
                                                    }}
                                                    inputProps={{
                                                        name: 'idCargo',
                                                        id: 'input-cargo',
                                                    }}
                                                    size="small"
                                                    disabled={isReadOnly}
                                                >
                                                    <option key={0} value={0}>{"(Seleccione)"}</option>
                                                    {listCargo.map((row) => (
                                                        <option key={row.id} value={row.id}>{row.descripcion}</option>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={7}>
                                            <Box display="flex" alignItems="center" gap={0}>
                                                <TextField
                                                    name="representante"
                                                    label="Representante"
                                                    value={row.representante || ""}
                                                    fullWidth
                                                    onChange={(event) => {
                                                        setItemValue(row.numero, "representante", event.target.value)
                                                    }}
                                                    size="small"
                                                    disabled={isReadOnly}
                                                    InputProps={{
                                                        readOnly: true,
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <Tooltip title={(row.idRepresentante > 0 ? "Editar" : "Registrar") + " Representante"} arrow>
                                                                    <IconButton aria-label="registrar representante" size="small" edge="end" disabled={isReadOnly} onClick={() => {
                                                                        setSelectId(row.idRepresentante)
                                                                        setSelectNumero(row.numero);
                                                                        openClosePersonRegister()
                                                                    }}>
                                                                        {row.idRepresentante > 0 ? <IconEdit fontSize="small" /> : <IconAddCircle fontSize="small" />}
                                                                    </IconButton>
                                                                </Tooltip>
                                                                <Tooltip title={"Buscar Representante"}>
                                                                    <IconButton aria-label="buscar representante" size="small" edge="end" disabled={isReadOnly} onClick={() => {
                                                                        setSelectNumero(row.numero);
                                                                        openCloseSearchPersona()
                                                                    }}>
                                                                        <IconSearch fontSize="small" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                                {/* <Tooltip title={"Quitar Representante"} arrow>
                                                    <IconButton aria-label="delete" size='small' disabled={isReadOnly} onClick={() => {
                                                        if (row.idPersona > 0) {
                                                            setSelectNumero(row.numero);
                                                            setOpenDialogDelete(true);
                                                        }
                                                        else {
                                                            dispatch(remove({sliceKey: sliceKey, numero: row.numero}));
                                                        }
                                                        }}>
                                                        <IconDelete />
                                                    </IconButton>
                                                </Tooltip> */}
                                            </Box>
                                        </Grid>
                                        <Grid item xs={6} sm={2}>
                                            <Box display="flex" alignItems="center" gap={0}>
                                                <FormControl required fullWidth>
                                                    <InputLabel htmlFor="input-estadolaboral">Estado</InputLabel>
                                                    <Select
                                                        native
                                                        label="Estado"
                                                        value={row.idEstadoLaboral || 0}
                                                        fullWidth
                                                        onChange={(event, newValue) => {
                                                            var id = event.nativeEvent.target.selectedIndex;

                                                            setItemValue(row.numero, "idEstadoLaboral", event.target.value)
                                                            setItemValue(row.numero, "estadoLaboral", event.nativeEvent.target[id].text)
                                                        }}
                                                        inputProps={{
                                                            name: 'idEstadoLaboral',
                                                            id: 'input-estadoLaboral',
                                                        }}
                                                        size="small"
                                                        disabled={isReadOnly}
                                                    >
                                                        <option key={0} value={0}>{"(Seleccione)"}</option>
                                                        {listEstadoLaboral.map((row) => (
                                                            <option key={row.id} value={row.id}>{row.descripcion}</option>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                                <Tooltip title={"Borrar Representante"} arrow>
                                                    <IconButton aria-label="delete" disabled={isReadOnly} onClick={() => {
                                                        if (row.id > 0) {
                                                            setSelectId(row.id);
                                                            setSelectNumero(row.numero);
                                                            setOpenDialogDelete(true);
                                                        }
                                                        else {
                                                            dispatch(remove({sliceKey: sliceKey, numero: row.numero}));
                                                        }

                                                    }}>
                                                        <IconDelete />
                                                    </IconButton>
                                                </Tooltip>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <FormControl required fullWidth
                    error={
                        Object.keys(validation).some(
                            key => validate?.[key] && validation[key].error
                        )
                    }
                >
                    {Object.keys(validation).map(key => (
                        validate?.[key] && validation[key].error && (
                            <HelperText key={key}>
                                {validation[key].message}
                            </HelperText>
                        )
                    ))}
                </FormControl>
            </Grid>
            <PersonSearch empresa="N" open={openSearchPersona} openClose={openCloseSearchPersona} setSelection={setSelectSearchPersona}/>
            <PersonRegister id={selectId} sliceKey="personRegister" open={openPersonRegister} openClose={openClosePersonRegister} setNewPersonSaved={setPersonSaved}/>
            <DialogYesNo
                open={openDialogDelete}
                openClose={openCloseDialogDelete}
                setYes={deleteMainEntity}
                setNo={() => { return }}
                titulo={"Borrar Representante"}
                texto={"Esta seguro de borrar el representante?"}
            ></DialogYesNo>
        </Grid>
    )
}

export default PersonRepresentative;
